import { ReactNode } from 'react';
import { ActivePollStatus } from '@online-webinar/store';

interface Props {
    activePollStatus: ActivePollStatus;
    children: ReactNode;
    isLandscape: boolean;
    isMobile: boolean;
}

export const PollDrawer = ({ activePollStatus, children, isLandscape, isMobile }: Props) => (
    <div
        className={`relative ${isMobile ? (isLandscape ? 'col-start-1 row-start-1' : 'col-start-1 row-start-2') : 'col-start-2 row-start-1 row-span-2'} ${activePollStatus !== ActivePollStatus.Inactive ? '' : 'hidden'} overflow-hidden pointer-events-none z-30`}
        data-testid="Poll"
    >
        {children}
    </div>
);
